const edicts = {
  title: "Edikte & OZUFs",
  filter: {
    from: "Zeitraum von",
    to: "bis",
    sourceToggleAriaLabel: "Datenquelle auswählen",
    onlyWithoutCounselor: "Nur Kund:innen ohne Berater anzeigen",
    validation: {
      toBeforeFrom: "„bis“ darf nicht vor „Zeitraum von“ liegen.",
      rangeTooLong: "Die ausgewählte Zeitspanne darf eine Woche nicht überschreiten.",
      rangeInFuture: "Der Zeitraum darf nicht in der Zukunft liegen.",
    },
  },
  source: {
    edikte: "Edikte",
    ozufs: "OZUFs",
  },
  results: {
    title: "Gefundene Einträge",
    count: "Anzahl:{{value}}",
    empty: "Keine Einträge für den gewählten Zeitraum gefunden.",
    emptyFiltered: "Keine Kund:innen ohne Berater im Ergebnis. Filter entfernen, um alle Einträge zu sehen.",
    error:
      "Das Register konnte nicht erreicht werden. Der Abgleich wurde nicht durchgeführt — bitte später erneut versuchen.",
  },
  columns: {
    id: "ID",
    debtor: "SCHULDNER:IN",
    birthday: "GEBURTSDATUM",
    city: "ORT",
    client: "KLIENT:IN",
    counselor: "BEARBEITER:IN",
    recorded: "EDIKT ERFASST",
    recordedLink: "Aktenvermerk",
  },
  detailDialog: {
    titleEdikt: "Edikt-Details",
    titleOzuf: "OZUF-Details",
    name: "Name",
    birthday: "Geburtsdatum",
    address: "Adresse",
    fileNumber: "Aktenzahl",
    court: "Gericht",
    content: "Inhalt",
    loading: "Details werden geladen",
    error: "Die Details konnten nicht geladen werden. Das Register war nicht erreichbar.",
    transfer: "§",
    transferTooltip: "Ediktsdaten übernehmen",
    // Keeps the visible „§“ in the accessible name, so speech input can address the button by what is on it.
    transferAriaLabel: "§ Ediktsdaten in den Kundenakt übernehmen",
  },
  transferResult: {
    title: "Ediktsdaten übernommen",
    proceedingCreated: "Ein neues Schuldenregulierungsverfahren wurde angelegt.",
    proceedingUpdated: "Das bestehende Schuldenregulierungsverfahren wurde befüllt.",
    openingDateSet: "Eröffnung am wurde übernommen.",
    openingDateKept: "Eröffnung am wurde nicht überschrieben.",
    openingDateMissing: "Das Edikt nennt kein Eröffnungsdatum — es wurde keines übernommen.",
    fileNumberSet: "Aktenzahl wurde übernommen.",
    fileNumberSkipped: "Aktenzahl konnte nicht übernommen werden und ist händisch einzutragen.",
    courtSet: "Bezirksgericht wurde übernommen.",
    courtSkipped: "Das Bezirksgericht konnte keinem Eintrag der Gerichtsliste zugeordnet werden.",
    offeredQuotaSet: "Quote angeboten wurde übernommen.",
    counselingTypeSet: "Beratungsart wurde auf „begleitet“ gesetzt.",
    hearingCreated: "Die Tagsatzung wurde im Verfahrensverlauf eingetragen.",
    hearingUpdated: "Die bestehende Tagsatzung wurde aktualisiert.",
    hearingMissing: "Das Edikt enthält keine Tagsatzung — es wurde kein Eintrag erstellt.",
    hearingTimeMissing:
      "Das Edikt nennt eine Tagsatzung, aber keine Uhrzeit — der Eintrag ist im Verfahrensverlauf händisch zu ergänzen.",
    hearingCaseNoteCreated: "Der Aktenvermerk „Tagsatzung“ wurde in den Vermerken angelegt.",
    hearingCaseNoteUpdated: "Der bestehende Aktenvermerk „Tagsatzung“ wurde aktualisiert.",
    hearingCaseNoteMissing: "Das Edikt enthält keine Tagsatzung — es wurde kein Aktenvermerk erstellt.",
    hearingCaseNoteTimeMissing:
      "Das Edikt nennt eine Tagsatzung, aber keine Uhrzeit — der Aktenvermerk „Tagsatzung“ ist händisch anzulegen.",
    hearingCaseNotePassed: "Die Tagsatzung ist bereits vorbei — es wurde kein Aktenvermerk „Tagsatzung“ erstellt.",
    assignmentCreated: "Die Aufgabe „Ende Anmeldefrist“ wurde erstellt.",
    assignmentUpdated: "Die bestehende Aufgabe „Ende Anmeldefrist“ wurde aktualisiert.",
    assignmentMissing: "Das Edikt enthält keine Anmeldungsfrist — es wurde keine Aufgabe erstellt.",
    assignmentNoCounselor:
      "Die Kund:in hat keine:n fixe:n Berater:in — es wurde keine Aufgabe „Ende Anmeldefrist“ erstellt.",
    assignmentDeadlinePassed:
      "Die Anmeldungsfrist ist bereits abgelaufen — es wurde keine Aufgabe „Ende Anmeldefrist“ erstellt.",
  },
  transferErrors: {
    notDebtSettlementRegister:
      "Dieses Edikt gehört nicht zum Schuldenregulierungsregister und ist händisch zu erfassen. Es wurde nichts übernommen.",
    sourceUnavailable: "Das Register war nicht erreichbar. Es wurde nichts in den Kundenakt übernommen.",
    unknown: "Die Ediktsdaten konnten nicht übernommen werden. Es wurde nichts in den Kundenakt geschrieben.",
  },
  notAssigned: "nicht zugewiesen",
  badge: {
    isClient: "SB-Klient:in",
    notClient: "Kein:e Klient:in",
  },
  actions: {
    loadData: "Daten laden",
    createAvAndTask: "AV und Aufgabe erstellen ({{value}})",
    createMailMerge: "Serienbrief erstellen ({{value}})",
  },
  mailMergeDialog: {
    title: "Serienbrief-Datenquelle schreiben",
    text_one:
      "Die Datenquelle <bold>{{fileName}}</bold> wird für {{count}} Nicht-Klient:in in den Ordner <path>{{folder}}</path> geschrieben. Eine vorhandene Datei mit diesem Namen wird überschrieben.",
    text_other:
      "Die Datenquelle <bold>{{fileName}}</bold> wird für {{count}} Nicht-Klient:innen in den Ordner <path>{{folder}}</path> geschrieben. Eine vorhandene Datei mit diesem Namen wird überschrieben.",
    confirm: "Datenquelle schreiben",
  },
  mailMergeResult: {
    title: "Serienbrief-Datenquelle geschrieben",
    text_one:
      "{{count}} Datensatz wurde in <bold>{{fileName}}</bold> im Ordner <path>{{folder}}</path> geschrieben. Die Briefe selbst erstellen Sie in Word mit der Serienbrief-Vorlage.",
    text_other:
      "{{count}} Datensätze wurden in <bold>{{fileName}}</bold> im Ordner <path>{{folder}}</path> geschrieben. Die Briefe selbst erstellen Sie in Word mit der Serienbrief-Vorlage.",
  },
  notifications: {
    recordsCreated_one: "Für {{count}} Edikt wurden Aktenvermerk und Aufgabe erstellt.",
    recordsCreated_other: "Für {{count}} Edikte wurden Aktenvermerke und Aufgaben erstellt.",
    recordsCreatedPartial:
      "Für {{count}} von {{selected}} Edikten wurden Aktenvermerk und Aufgabe erstellt. Die übrigen konnten nicht verarbeitet werden und können erneut ausgewählt werden.",
    recordsCreatedNone: "Es konnte kein Edikt verarbeitet werden. Bitte später erneut versuchen.",
  },
};

export default edicts;
